<template>
  <div v-if="event.title">
    <div class="text-xs-center pb-3">
      <img src="https://d2h7nbyku08cks.cloudfront.net/1759960554085_yssew26pe_6lb.jpg" alt="Logo"
        style="max-height: 300px; max-width: 80%">
    </div>
    <v-layout align-center justify-center wrap class="mb-4 pa-2">
      <v-flex xs12 sm8>
        <h2>{{ event.title }}</h2>
        <p v-html="event.description"></p>
        Veranstaltungsdatum: {{ event.date | stringToDate }}<br />
      </v-flex>
    </v-layout>

    <v-layout row wrap align-center justify-center fill-width fill-height v-if="!done" class="mx-5">
        <v-layout row wrap style="flex-grow: 1" fill-width xs12>
          <v-flex xs12 md6 class="px-2">
            <v-text-field
              label="Vorname"
              outline
              v-model="forename"
              :disabled="loading" />
          </v-flex>
          <v-flex xs12 md6 class="px-2">
            <v-text-field
              label="Nachname"
              outline
              v-model="surname"
              :disabled="loading" />
          </v-flex>
        </v-layout>
      <v-flex class="px-2" xs12>
        <v-text-field
          label="Email"
          required
          outline
          :rules="emailRules"
          v-model="email"
          :disabled="loading" />
      </v-flex>

    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-if="event.capacityLeft <= 0">
      <v-flex xs12 sm8>
        Alle Plätze sind bereits vergeben.
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-else-if="!done">
      <v-flex xs12 sm8>
        <v-layout wrap>
          <v-flex xs8 offset-xs2>
            <v-menu offset-y>
              <v-btn
                slot="activator"
                color="primary"
                dark
                :loading="loading"
              >
                Annehmen
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in items"
                  :key="index"
                  @click="accept(index)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex xs12 mt-4 px-2>
            Für weitere Informationen darüber, wie wir Ihre personenbezogenen Daten verarbeiten und schützen, lesen Sie
            bitte unsere <a href="https://www.rubas-versicherungsmakler.at/datenschutz.html">Datenschutzrichtlinie</a>.
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-else-if="done">
      <v-flex xs12 sm8>
        Sie haben sich erfolgreich angemeldet.
      </v-flex>
    </v-layout>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import { Storage } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      items: [
        {title: 'Ohne Begleitpersonen'},
        {title: '1 Begleitperson'},
        {title: '2 Begleitpersonen'},
        {title: '3 Begleitpersonen'},
      ],
      email: '',
      forename: '',
      surname: '',
      imageUrl: '',
      loading: false,
      select: null,
      checkbox: false,
      emailRules: [
        (v) => !!v || 'E-mail ist ein Pflichtfeld',
        (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
      ],
      done: false,
    };
  },
  computed: {
    ...mapGetters({
      event: 'pub/eventGuest/event',
      guest: 'pub/eventGuest/guest',
    }),
  },
  methods: {
    ...mapActions({
      readQrEvent: 'pub/eventGuest/readQr',
      storeAcceptQr: 'pub/eventGuest/acceptQr',
      storeDeny: 'pub/eventGuest/deny',
      startLoader: 'common/loader/start',
      stopLoader: 'common/loader/stop',
    }),
    accept(count) {
      if (!this.email || !(/.+@.+/.test(this.email))) {
        return;
      }

      this.loading = true;
      this.storeAcceptQr({
        eventId: '0b5b0461-2a47-4e20-952d-fd3f80861443',
        companions: count,
        guest: {email: this.email, forename: this.forename, surname: this.surname},
      })
        .then(() => this.readQrEvent({eventId: '0b5b0461-2a47-4e20-952d-fd3f80861443'}))
        .then(() => {
          this.done = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    this.startLoader();
    await this.readQrEvent({eventId: '0b5b0461-2a47-4e20-952d-fd3f80861443'});

    if (this.event.capacityLeft) {
      this.items = this.items.slice(0, Math.min(this.event.capacityLeft, 4));
    }


    this.imageUrl = await Storage.get(this.event.logo);
    this.stopLoader();
  },
};
</script>
